/* bz-enclosure-lanes.js
   Drives the Enclosures lane chips (snippets/bz-enclosure-lanes.liquid) as an in-place
   filter over the product grid. Added 2026-08-17.

   The chips are buttons, not links, by ZZ's call: clicking a lane must never load another
   collection page. Everything happens here. That also means there is no navigation
   fallback, so this file is careful to fail visible rather than fail silent: if it cannot
   filter honestly it leaves every tile on screen instead of hiding things. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-bz-lane-filter]');
  var grid = document.querySelector('[data-bz-grid]');
  if (!bar || !grid) return;

  var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-bz-lane]'));
  var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-bz-marks]'));
  if (!chips.length || !tiles.length) return;

  var noteTarget = document.querySelector('[data-bz-lane-note-target]');
  var status = document.querySelector('[data-bz-lane-status]');

  /* If the grid is ever paginated, this page holds only a slice of the lane. We still
     filter, because the chips have nowhere else to send the shopper, but the status line
     says "on this page" so the count is never passed off as the whole lane. */
  var total = parseInt(bar.getAttribute('data-bz-lane-total'), 10);
  var isPartial = !isNaN(total) && tiles.length < total;

  function matches(tile, lane) {
    if (!lane) return true;
    var marks = ' ' + (tile.getAttribute('data-bz-marks') || '') + ' ';
    return marks.indexOf(' ' + lane + ' ') !== -1;
  }

  function laneName(chip) {
    var el = chip.querySelector('.bz-encl-chip__name');
    return el ? el.textContent.trim() : '';
  }

  /* Recount every chip from the tiles actually on the page. The Liquid number comes from
     the lane collection, which is right in every case we ship today, but recounting means
     a badge can never promise a total that clicking it fails to produce. */
  chips.forEach(function (chip) {
    var lane = chip.getAttribute('data-bz-lane');
    var n = 0;
    tiles.forEach(function (tile) {
      if (matches(tile, lane)) n++;
    });
    var badge = chip.querySelector('.bz-encl-chip__count');
    if (badge) badge.textContent = String(n);
  });

  function apply(chip, announce) {
    var lane = chip.getAttribute('data-bz-lane');
    var shown = 0;

    tiles.forEach(function (tile) {
      var ok = matches(tile, lane);
      tile.hidden = !ok;
      if (ok) shown++;
    });

    chips.forEach(function (other) {
      var on = other === chip;
      other.classList.toggle('is-active', on);
      other.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (noteTarget) noteTarget.textContent = chip.getAttribute('data-bz-lane-note') || '';

    if (status && announce) {
      var suffix = isPartial ? ' on this page' : '';
      status.textContent = lane
        ? 'Showing ' + shown + ' ' + (shown === 1 ? 'size' : 'sizes') + ' in ' + laneName(chip) + suffix + '.'
        : 'Showing all ' + shown + suffix + '.';
    }

    grid.setAttribute('data-bz-lane-active', lane || '');

    /* Hash only, so the lane survives a reload or a shared link without ever loading a
       page. replaceState rather than pushState so the back button leaves the page instead
       of walking back through every chip the shopper tried. */
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', lane ? '#lane=' + lane : window.location.pathname + window.location.search);
    }
  }

  bar.addEventListener('click', function (event) {
    var chip = event.target.closest ? event.target.closest('[data-bz-lane]') : null;
    if (chip && bar.contains(chip)) apply(chip, true);
  });

  var deepLink = /#lane=([a-z0-9-]+)/i.exec(window.location.hash || '');
  if (deepLink) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-bz-lane') === deepLink[1]) {
        apply(chips[i], false);
        break;
      }
    }
  }

  bar.setAttribute('data-bz-lane-ready', 'true');
})();
